export default {
  // 1: 2301, // 상담사에게 콜이 인입되었습니다.
  CG_CALL_APP_INCOMMING: 2301, // 상담사에게 콜이 인입되었습니다.
  CG_CALL_APP_OUTGOING: 2302, // 상담사가 콜을 발신 했습니다.
  CG_CALL_APP_ACTIVE: 2303, // 상담사가 통화중입니다.
  CG_CALL_APP_TAKE_OVER_OUT: 2304, // 진행중인 상담을 다른 상담사에게 호전환(상담이관)하였습니다.
  CG_CALL_APP_TAKE_OVER_IN: 2305, // 다른 상담사로부터 호전환 상담(상담이관)이 인입되었습니다.
  CG_CALL_APP_CLOSE_CUSTOMER: 2306, // 상담 종료후 상담이력을 저장하고 있습니다.(고객)
  CG_CALL_APP_CLOSE_AGENT: 2307, // 상담 종료후 상담이력을 저장하고 있습니다.(상담사)
  CG_CALL_APP_WAITING_SUMMARY: 2308, // 전화상담 종료후 상담이력을 저장하고있습니다.
  CG_CALL_APP_COMPLETE_COUNCELING: 2309, // 상담이 완료되었습니다.
  CG_CALL_APP_SAVE_RESERVE_COUNCELING: 2310, // 추가상담이 필요하여 추가상담을 예약하였습니다.
  CG_CALL_APP_AUTO_COMPLETE_RESERVE_CALL: 2318, // 예약콜이 상담완료후 종료되었습니다.
  CG_CALL_APP_UPDATE_COUNCELING: 2321, // 상담이력을 수정하였습니다.
  CG_CALL_APP_SAVE_RESERVE_MULTI_COUNCELING: 2325, // 대량 예약콜이 접수되었습니다.
  CG_CALL_APP_CONFERENCED_CALL_OUT: 2326, // 상담사가 3자통화를 요청했습니다.
  CG_CALL_APP_CONFERENCED_CALL_IN: 2327, // 다른 상담사로부터 3자통화 상담이 인입되었습니다.
  CG_CALL_APP_MODIFY_RESERVE_COUNCELING: 2328, // 예약 상담을 수정하였습니다.
  CG_CALL_APP_DISTRIBUTION: 2329, // 예약상담을 %s상담사에게 할당하였습니다.
  CG_CALL_APP_NOT_DISTRIBUTION: 2330, // 예약상담을 할당을 취소하였습니다.
  CG_CALL_APP_PASSIVITY_FINISH: 2331, // 예약상담을 수동 처리하였습니다.
  CG_CALL_APP_SEND_IVR: 2332 // IVR 시나리오 분류 발송
};



// WEBPACK FOOTER //
// ./src/store/modules/call/ticketEvent.js